<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.group_name"
                    placeholder="次品组"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-select v-model="form.city" placeholder="城市">
                  <el-option value="0" label="全部"></el-option>
                  <el-option
                    v-for="item in citys"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="form.status" placeholder="状态">
                  <el-option key="" value="" label="全部"></el-option>
                  <el-option
                    v-for="item in isUse"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-form-item label="创建时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="resData" :span="24" class="data-statics">
        数据汇总:&nbsp;&nbsp;&nbsp;&nbsp;次品组{{ resData.total }}组
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto"
            type="primary"
            size="mini"
            @click="addPg"
            >+创建次品组</el-button
          >
          <el-button type="success" size="mini" @click="output">导出</el-button>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="dgid"
              label="次品组id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="group_name"
              label="次品组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="defective_group_city"
              label="城市"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_num"
              label="绑定商家数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="member_num"
              label="次品员数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="defective_group_status"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="创建时间"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" @click="editDg(scope.row)">
                  编辑</el-button
                >
                <el-button type="text" @click="PgLog(scope.row)">
                  查看日志</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <el-dialog title="操作日志" :visible.sync="logVisible">
            <el-table :data="logData">
              <el-table-column
                property="action_type"
                label="事件"
                align="center"
              ></el-table-column>
              <el-table-column label="内容" align="center">
                <template slot-scope="scope">
                  <div v-html="scope.row.action_desc" />
                </template>
              </el-table-column>
              <el-table-column
                property="action_admin"
                label="操作人"
                align="center"
              ></el-table-column>
              <el-table-column
                property="create_time"
                label="操作时间"
                align="center"
              ></el-table-column>
            </el-table>
          </el-dialog>
          <el-dialog
            title="添加/编辑次品组"
            width="20%"
            :visible.sync="editVisible"
            :before-close="closeEditDefective"
          >
            <el-form
              :model="defective_form"
              label-width="100px"
              label-position="left"
            >
              <el-form-item
                label="次品组名称"
                required
                :hide-required-asterisk="true"
              >
                <el-input
                  v-model="defective_form.group_name"
                  style="width: 200px"
                ></el-input>
              </el-form-item>
              <el-form-item label="绑定城市" required>
                <el-select v-model="defective_form.city" placeholder="城市">
                  <el-option
                    v-for="item in citys"
                    v-if="item.value > 0"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态" required>
                <el-select v-model="defective_form.status" placeholder="状态">
                  <el-option
                    v-for="item in isUse"
                    v-if="item.value > 0"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button size="small" @click="closeEditDefective">
                取 消</el-button
              >
              <el-button size="small" type="primary" @click="saveDefective">
                确 定</el-button
              >
            </span>
          </el-dialog>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="resData.page"
            background
            layout="total, prev, sizes, pager, next, jumper "
            :total="resData.total"
            :page-size="50"
            :page-sizes="[10, 50, 100]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  data() {
    return {
      logVisible: false,
      editVisible: false,
      resData: null,
      logData: null,
      form: {
        pgname: "",
        create_time: [],
        city: "",
        is_use: "",
        psize: 50,
        p: 1,
      },
      defective_form: {},
      citys: CITY,
      isUse: [
        {
          value: "1",
          label: "启用",
        },
        {
          value: "2",
          label: "禁用",
        },
      ],
      loading: false,
      tableLoading: false,
      url: "/erp/Defective/getGroups",
      curPage: 1,
      filterFold: false,
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.tableLoading = false;
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.p = val;
      this.tableLoading = true;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.form.psize = val;
      this.form.p = 1;
      this.tableLoading = true;
      this.fetchData();
    },
    search() {
      this.form.p = 1;
      this.loading = true;
      this.fetchData();
    },
    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    addPg() {
      this.defective_form = {
        group_name: "",
        city: "",
        status: "1",
      };
      this.editVisible = true;
    },
    editDg(row) {
      this.defective_form = {
        id: row.dgid,
        group_name: row.group_name,
        city: row.city,
        status: row.status,
      };
      this.editVisible = true;
    },
    PgLog(row) {
      this.$http
        .post("/erp/Defective/getLog", {
          type: "group",
          id: row.dgid,
        })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.logData = res.data.data.log;
            this.logVisible = true;
          }
        });
    },
    saveDefective() {
      this.$http
        .post("/erp/Defective/saveGroups", this.defective_form)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success("编辑成功");
            this.closeEditDefective();
            this.fetchData(true);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    closeEditDefective() {
      this.editVisible = false;
      this.defective_form = {
        group_name: "",
        status: 0,
        city: 0,
      };
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/defectivegroup/group.vue